import { createAction, props } from "@ngrx/store";

export const setPayment = createAction(
  //setPayment
  "[Payment] Set Payment",
  props<{ paymentObject: object }>()
);
